module.exports = __webpack_public_path__ + "img/icon_map_4_yj_hg.7b3682b6.png";